/**
 * @generated SignedSource<<5691c2f08be3eeabeee5ea0fa638c455>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuctionItemSubscription_item$data = {
  readonly isSold: boolean | null;
  readonly isUnavailable: boolean | null;
  readonly relevantAuctionLot: {
    readonly endDate: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useAuctionState_item">;
  readonly " $fragmentType": "AuctionItemSubscription_item";
};
export type AuctionItemSubscription_item$key = {
  readonly " $data"?: AuctionItemSubscription_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"AuctionItemSubscription_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "page"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuctionItemSubscription_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnavailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "AuctionLot",
      "kind": "LinkedField",
      "name": "relevantAuctionLot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionState_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "80d8ead28376d0e49c6d6b11e9a04a72";

export default node;
